import useApi from '../../common/hooks/useApi'
import useSWR from 'swr'
import { type Country } from '@amici/myamici-api-client'

interface UseIsoCountryHook {
  isoCountries: Country[] | undefined
  isLoading: boolean
  hasData: boolean
  loadingError: any
}

function useIsoCountries (): UseIsoCountryHook {
  const { metadataApi, fetcherWithoutParams } = useApi()

  const {
    data,
    isLoading,
    error: loadingError
  } = useSWR(
    'allIsoCountries',
    async () => await fetcherWithoutParams(metadataApi.getAllISOCountries())
  )

  const hasData = Array.isArray(data) && data.length > 0

  return {
    isoCountries: data,
    isLoading,
    hasData,
    loadingError
  }
}

export default useIsoCountries
